var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupertagNature = function SvgSupertagNature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 84,
    fill: "none",
    viewBox: "0 0 86 84"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m47.34 56.914 9.873-9.843 26.756 26.756M2 82l34.93-34.93 16.047 16.048M41.254 29.233a9.395 9.395 0 0 0-9.396-9.396 9.395 9.395 0 0 0-9.396 9.396 9.395 9.395 0 0 0 9.396 9.396 9.395 9.395 0 0 0 9.396-9.396M31.858 13.275V2M48.771 30.158h11.245M3.7 30.158h11.245M45.013 16.079 52.5 8.592M11.217 49.875l7.487-7.487M11.217 8.592l7.487 7.487"
  })));
};
export default SvgSupertagNature;